<template>
  <v-sheet class="pa-2" border color="grey-lighten-5" elevation="0">
    <div class="text-h6">GIA | ID. {{ gia.id }}</div>
    <div class="d-flex sm-gap">
      <v-chip variant="elevated" color="white" elevation="0" border> GIA payée : {{ gia.prix }}€ </v-chip>
      <v-chip variant="elevated" color="white" elevation="0" border>
        <v-icon v-if="gia.valide == '1'" icon="mdi-check" color="green-darken-4"></v-icon>
        <v-icon v-else icon="mdi-close" color="deep-orange-darken-4"></v-icon>
        Validé
      </v-chip>
    </div>
  </v-sheet>
</template>

<script>
export default {
  props: ["gia"],
};
</script>

<style lang="scss" scoped>
</style>